import { Vec2 } from "./vec2";

export namespace Bounds {

    export function c(min: Vec2, max: Vec2): Bounds {
        return { min, max };
    }

    export function fromPoints(a: Vec2, b: Vec2) {
        return Bounds.c(Vec2.min(a, b), Vec2.max(a, b));
    }

    export function fromSize(size: Vec2) {
        return Bounds.c(Vec2.zero(), size);
    }

    // Math

    export function size(bounds: Bounds): Vec2 {
        return Vec2.sub(bounds.max, bounds.min);
    }

    export function center(bounds: Bounds): Vec2 {
        return Vec2.scale(Vec2.add(bounds.min, bounds.max), 0.5);
    }

    export function contains(bounds: Bounds, point: Vec2): boolean {
        return point.x >= bounds.min.x && point.x < bounds.max.x && point.y >= bounds.min.y && point.y < bounds.max.y;
    }

    export function clamp(bounds: Bounds, point: Vec2): Vec2 {
        return Vec2.clamp(point, bounds.min, bounds.max);
    }

}